module.exports = __webpack_public_path__ + "static/media/searchsvg.b2272fd9.svg";